import { createStore } from 'vuex'
import repository from "../api/repository";

const store = createStore({
	modules: {
		auth: {
			state: {
				user: localStorage.user ? JSON.parse(localStorage.getItem('user')) : null,
				lang: localStorage.locale ? localStorage.getItem('locale') : 'en-en'
			},

			getters: {
				user: state => state.user,
				authenticated: state => state.user !== null,
			},

			mutations: {
				SET_USER(state, user) {
					state.user = user;
					localStorage.user = JSON.stringify(user);
				},
				SET_LANG(state, lang) {
					state.lang = lang;
				},
				REMOVE_USER(state) {
					state.user = null
					localStorage.removeItem('user')
				}
			},

			actions: {
				async checkAuth({ commit }, user = localStorage.getItem('user')) {
					await repository.createSession();
					const { data } = await repository.checkAuth(user);
					if (!data) {
						return data;
					}
					if (data.user) {
						commit('REMOVE_USER');
						commit('SET_USER', data.user);

						localStorage.user = JSON.stringify(data.user);
					}
			
					return data;
				},
				async login({ commit }, user) {
					await repository.createSession();
					const { data } = await repository.login(user);
					if (data.user){
						commit('SET_USER', data.user);
						localStorage.user = JSON.stringify(data.user);
					}						
					
					return data;
				},
				async directLogin({ commit }, key) {
					await repository.createSession();
					const { data } = await repository.directLogin(key);
					if (data.user){
						commit('SET_USER', data.user);
						localStorage.user = JSON.stringify(data.user);
					}						
					
					return data;
				},
				async loginSocial({ commit }, social) {
					await repository.createSession();
					const { data } = await repository.loginSocial(social);
					if (data.user){
						commit('SET_USER', data.user);
						localStorage.user = JSON.stringify(data.user);
					}
					return data;
				},

				async logout({ commit }) {
					await repository.logout();
					commit('SET_USER', null);
					localStorage.removeItem('user');
				},

				async register({commit}, user) {
					await repository.createSession();
					const { data } = await repository.register(user);
					if (data.user){
						commit('SET_USER', data.user);
						localStorage.setItem('user', JSON.stringify(data.user));
					}
					return data;
				},

				async registerAddress({commit}, user) {
					await repository.createSession();
					const { data } = await repository.registerAddress(user)
					if (data.user){
						commit('SET_USER', data.user);
						localStorage.setItem('user', JSON.stringify(data.user));
					}
					
					return data;
				},
				async registerContract({commit}, user) {
					// await repository.createSession();
					const { data } = await repository.registerContract(user)
					if (data.user){
						commit('SET_USER', data.user);
						localStorage.setItem('user', JSON.stringify(data.user));
					}
					return data;
				},
				async registerJobTypes({commit}, user) {
					// await repository.createSession();
					const { data } = await repository.registerJobTypes(user)
					if (data.user){
						commit('SET_USER', data.user);
						localStorage.setItem('user', JSON.stringify(data.user));
					}
					return data;
				},
				async registerShifts({commit}, user) {
					// await repository.createSession();
					const { data } = await repository.registerShifts(user)
					if (data.user){
						commit('SET_USER', data.user);
						localStorage.setItem('user', JSON.stringify(data.user));
					}
					return data;
				},
				async registerTransportation({commit}, user) {
					// await repository.createSession();
					const { data } = await repository.registerTransportation(user)
					if (data.user){
						commit('SET_USER', data.user);
						localStorage.setItem('user', JSON.stringify(data.user));
					}
					return data;
				},
				async isActiveToggle({commit}, data) {
					await repository.createSession();
					const { res } = await repository.isActiveToggle(data)
					if (res.user){
						commit('SET_USER', res.user);
						localStorage.setItem('user', JSON.stringify(res.user));
					}
					return res;
				},
				async forgotPassword({commit}, email) {
					await repository.createSession();
					const {data} = await repository.forgotPassword(email)
					return data;
				},
				async resetPassword({commit}, data) {
					await repository.createSession();
					const {res} = await repository.resetPassword(data)
					return res;
				},
				clearAuth({commit}) {
					commit('REMOVE_USER')
				},
				async createSession({commit}) {
					await repository.createSession();
				}

			}
		}
	}
})

export default store;